import React from 'react'

interface Service {
  id: number;
  title: string;
  description: string;
  icon: string;
  color: 'primary' | 'secondary';
}

const WhatIDo = () => {
      const services: Service[] = [
    {
      id: 1,
      title: 'Import Solutions',
      description: 'With extensive experience in global trade, Siddhant Exim Academy excels in import compliance, logistics optimization, and comprehensive support. We also offer Third-Party Inspection, Business Process Outsourcing, and Management services to ensure quality, efficiency, and performance. Trust us to streamline your import processes and enhance operational excellence.',
      icon: 'fas fa-ship',
      color: 'primary'
    },
    {
      id: 2,
      title: 'Buy',
      description: 'Welcome to Siddhant Exim Academy, a division of Ratanlal Traders Intead Pvt. Ltd, specializing in seamless global export. We offer expert consulting, compliance, and logistics solutions to streamline your export processes. Our services include Third-Party Inspection, Business Process Outsourcing, and Call Centre solutions to ensure your success in international markets.',
      icon: 'fas fa-search-dollar',
      color: 'secondary'
    },
    {
      id: 3,
      title: 'Export Services',
      description: 'Welcome to Siddhant Exim Academy, a division of Ratanlal Traders Intead Pvt. Ltd Specializing in global trade, we offer expert consulting, compliance assurance, and logistics optimization for seamless exports. Our services also include Third-Party Inspection, Business Process Outsourcing, and Call Centre solutions. Trust us for your export success.',
      icon: 'fas fa-plane',
      color: 'secondary'
    },
    {
      id: 4,
      title: 'Sales Growth',
      description: 'At Siddhant Exim Academy, we drive sales success with tailored strategies and expert guidance. Our team excels in optimizing sales processes, enhancing customer engagement, and increasing market reach. We offer comprehensive solutions to boost sales performance, ensuring your business achieves its revenue goals and thrives in a competitive landscape.',
      icon: 'fas fa-chart-line',
      color: 'primary'
    }
  ];
  return (
    <div>
        {/* Services Section */}
      <section className="py-2 bg-white mt-10">
        <div className="container mx-auto px-4 sm:px-6 lg:px-8">
          {/* Section Heading - Animate from top */}
          <div className="text-center mb-16 animate-top">
            <h2 className="text-3xl sm:text-4xl font-bold text-gray-800 mb-4">
              WHAT I <span className="text-amber-500"> DO</span>
            </h2>
            <p className="text-xl text-gray-600 max-w-2xl mx-auto">
              Comprehensive solutions designed to meet your unique business needs and drive sustainable growth.
            </p>
          </div>
          
          {/* Services Grid with alternating animations */}
          <div className="grid grid-cols-1 md:grid-cols-2 gap-8">
            {services.map((service, index) => (
              <div 
                key={service.id}
                className={`service-item group bg-white rounded-2xl p-8 border border-gray-200 hover:border-teal-300 transition-all duration-300 hover:shadow-xl ${
                  index % 2 === 0 ? 'animate-left' : 'animate-right'
                } ${
                  index % 2 === 1 ? 'hover:transform hover:-translate-y-2' : ''
                }`}
              >
                <div className={`w-14 h-14 rounded-xl flex items-center justify-center mb-6 ${
                  service.color === 'primary' 
                    ? 'bg-teal-100 text-teal-600' 
                    : 'bg-amber-100 text-amber-600'
                }`}>
                  <i className={`${service.icon} text-xl`}></i>
                </div>
                
                <h3 className={`text-2xl font-bold mb-4 ${
                  service.color === 'primary' ? 'text-teal-700' : 'text-amber-700'
                }`}>
                  {service.title}
                </h3>
                
                <p className="text-gray-600 leading-relaxed mb-6">
                  {service.description}
                </p>
              </div>
            ))}
          </div>
        </div>
      </section>
    </div>
  )
}

export default WhatIDo
